theme.alinga = theme.alinga || {};
theme.alinga.custTestimonialSlider = () => {
 const reviewSliderImg = new Swiper("#testimoNialImgSlider", {
    slidesPerView: 1,
    loop: true,
    effect: 'fade',
    speed:500,
    autoplay: {
      delay: 3000,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  })
  const reviewSlider = new Swiper("#reviewsSlider", {
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 3000,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        autoplay: {
          delay: 3000,
        },
        loop:true
      },
      1024: {
        slidesPerView: 1,
        autoplay: {
          delay: 3000,
        },
      }
    }
  });
  reviewSliderImg.on('slideChange', () => {
    let currIndex = reviewSliderImg.activeIndex;
    reviewSlider.slideTo(currIndex)
  });
  reviewSlider.on('slideChange', () => {
    let currIndex = reviewSlider.activeIndex;
    reviewSliderImg.slideTo(currIndex)
  });
} 

document.addEventListener('DOMContentLoaded', () => {
  theme.alinga.custTestimonialSlider();
});

